export const HOUR_START = 7;
export const HOUR_END = 20;
export const ROW_HEIGHT = 48;

export const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const addMonths = (d, n) => {
  const x = new Date(d);
  x.setMonth(x.getMonth() + n);
  return x;
};

export const startOfWeek = (d) => {
  const x = startOfDay(d);
  const day = x.getDay();
  const diff = (day + 6) % 7;
  x.setDate(x.getDate() - diff);
  return x;
};

export const endOfWeek = (d) => addDays(startOfWeek(d), 6);

export const startOfMonth = (d) => {
  const x = startOfDay(d);
  x.setDate(1);
  return x;
};

export const endOfMonth = (d) => {
  const x = startOfMonth(d);
  x.setMonth(x.getMonth() + 1);
  x.setDate(0);
  return x;
};

export const sameDay = (a, b) => {
  if (!a || !b) return false;
  const x = new Date(a);
  const y = new Date(b);
  return (
    x.getFullYear() === y.getFullYear() &&
    x.getMonth() === y.getMonth() &&
    x.getDate() === y.getDate()
  );
};

export const formatHour = (h) => {
  const suffix = h >= 12 ? 'PM' : 'AM';
  const hh = ((h + 11) % 12) + 1;
  return `${hh} ${suffix}`;
};

export const formatTimeShort = (d) => {
  const date = new Date(d);
  return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
};

export const formatRange = (view, anchor) => {
  if (view === 'day') {
    return anchor.toLocaleDateString(undefined, {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }
  if (view === 'week') {
    const s = startOfWeek(anchor);
    const e = endOfWeek(anchor);
    const sameMonth = s.getMonth() === e.getMonth();
    const sameYear = s.getFullYear() === e.getFullYear();
    const sFmt = s.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: sameYear ? undefined : 'numeric',
    });
    const eFmt = e.toLocaleDateString(undefined, {
      month: sameMonth ? undefined : 'short',
      day: 'numeric',
      year: 'numeric',
    });
    return `${sFmt} – ${eFmt}`;
  }
  return anchor.toLocaleDateString(undefined, { month: 'long', year: 'numeric' });
};

export const buildWeekDays = (anchor) => {
  const start = startOfWeek(anchor);
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
};

export const buildMonthCells = (anchor) => {
  const start = startOfWeek(startOfMonth(anchor));
  const cells = [];
  for (let i = 0; i < 42; i += 1) cells.push(addDays(start, i));
  return cells;
};

export const buildHourSlots = (startHour = HOUR_START, endHour = HOUR_END) => {
  const out = [];
  for (let h = startHour; h <= endHour; h += 1) out.push(h);
  return out;
};

export const toLocalInputValue = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
};

export const fromLocalInputValue = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d;
};

export const durationMinutes = (appt) => {
  if (!appt) return 0;
  if (appt.end_time) {
    const start = new Date(appt.start_time).getTime();
    const end = new Date(appt.end_time).getTime();
    if (!Number.isNaN(start) && !Number.isNaN(end) && end > start) {
      return Math.round((end - start) / 60000);
    }
  }
  if (appt.duration_minutes) return Number(appt.duration_minutes);
  return 60;
};
